import { DecimalLocalizator } from "sb-helpers";
var StaticDecimalLocalizator = /** @class */ (function () {
    function StaticDecimalLocalizator() {
    }
    StaticDecimalLocalizator.initialize = function (oddFormatters, defaultFormatter) {
        this._localizator = new DecimalLocalizator({
            oddFormatters: oddFormatters,
            pointFormatter: defaultFormatter
        });
    };
    StaticDecimalLocalizator.getInstance = function () {
        return this._localizator;
    };
    StaticDecimalLocalizator.dispose = function () {
        this._localizator = undefined;
    };
    StaticDecimalLocalizator._localizator = undefined;
    StaticDecimalLocalizator._siteDecimalSeparator = undefined;
    return StaticDecimalLocalizator;
}());
export { StaticDecimalLocalizator };
//# sourceMappingURL=StaticDecimalLocalizator.js.map